import './create-search-dropdown-filter';
import store from '../../../../store/store';
import { CreateSearchDropdownFilter } from './create-search-dropdown-filter';
import { FilterAction } from '../interfaces/create-search-filter.interface';
import { connect } from 'pwa-helpers';
import { customElement, property } from 'lit/decorators.js';

@customElement('mhecomm-create-search-country-filter')
export class CreateSearchCountryFilter extends connect(store)(CreateSearchDropdownFilter) {
  @property()
  ariaLabel = 'Select the country that you want to search in';

  @property()
  defaultCountryCode = '';

  @property()
  defaultOptionDisplayValue = 'Please select';

  @property()
  defaultOptionFormValue = 'none';

  @property()
  loadingDisplayValue = 'Loading countries';

  connectedCallback(): void {
    this.actionChange = FilterAction.CLEAR_AND_CHANGE;
    this.actionReset = FilterAction.CLEAR;

    super.connectedCallback();

    if (this.options[this.defaultCountryCode]) {
      this.selectedOption = this.defaultCountryCode;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-create-search-country-filter': CreateSearchCountryFilter;
  }
}
